import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/check.svg
 */
const IconCheck: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.645 7.176L9.58 18.239l-6.226-6.226 1.415-1.415L9.58 15.41l9.65-9.649 1.414 1.415z"
      fill="currentColor"
    />
  </svg>
);

export default IconCheck;
